<template>
  <input
      @keyup.enter="$emit('enter')"
      ref="inputRef"
      type="text"
  />
</template>

<script>
import { useCurrencyInput } from 'vue-currency-input';

export default {
  name: "CurrencyInput",
  props: {
    modelValue: Number,
    options: Object,
  },
  setup(props) {
    const { inputRef } = useCurrencyInput(props.options);

    return { inputRef };
  },
};
</script>

<style lang="scss" scoped>
input {
  border: 1px solid #d0d4da;
  background: #fff;
  padding: .5rem;
  display: inline-block;
  box-shadow: none;
  font-size: 15px;
  margin-top: .3em;
  width: 60%;
  height: 2rem;
}
</style>
